/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { Row, Col } from "components/Grid";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import FileModal from "components/FileModal";
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import DialogComponent, { DialogConfirm, DialogRejected, ContentTextArea, TextArea2 } from 'components/Dialog';
import FilesAttachment from "components/FilesAttachment";
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import StepNavigation from "components/StepNavigation/index";
import HasPermission from "components/HasPermission/index";

export default function ApprovalInvoiceNotPreAgreed(props) {

    const [file, setFile] = useState();
    const [summary, setSummary] = useState({});
    const [userComments, setUserComments] = useState(null);
    const [canApprove, setCanApprove] = useState(false);
    const [isDenied, setIsDenied] = useState(false);
    const [historymsg, setHistorymsg] = useState([]);
    const [isBound, setIsBound] = useState(false);
    
    const authContext = useContext(GlobalAuthContext);
    const formik = useRef(null);
    const history = useHistory();
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();
    const loading = useContext(GlobalLoaderContext);

    function handleHistoryMessage() {
        let tempmessage = "";
        if (historymsg?.length >= 1) {
            historymsg.map(
                (message, index) => {
                    const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
              `;
                    tempmessage = (tempmessage + tempMsg);
                }
            )
            return tempmessage;
        }
    };

    function handleSummary() {
        loading.start();
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestHeaderNbi(props.match.params.idOperation)
            .then(response => response.json()).then(data => {
                setSummary({
                    typeOfCover: data.ret_value.typeOfCover,
                    client: data.ret_value.client,
                    obligorCoding: data.ret_value.obligorCoding,
                    responseBy: data.ret_value.responseBy,
                    internalContact: data.ret_value.internalContact,
                    broker: data.ret_value.broker,
                    dealCode: data.ret_value.deal,
                    nmFacility: data.ret_value.nmFacility,
                    nmObligor: data.ret_value.nmObligor,
                    projectName: data.ret_value.projectName,
                });

                if (data.ret_value.paymentPackMessage) {
                    formik.current?.setFieldValue('paymentPackMessage', data.ret_value.paymentPackMessage);
                }

                setHistorymsg(data.ret_value.historical);
            })
            .catch((error) => {
                mc.error("Erro executando consulta\n" + error);
                console.error('fitPostSummary - Error:', error);
            });
        loading.stop();
    };

    function handleFile() {
        fitinsur.setAuthToken(authContext.token);
        fitinsur.paymentPackHtmlModal(props.match.params.idOperation)
            .then(x => x.json())
            .then(resp => {
                if (resp.ret_code === 200) {
                    setFile(resp.ret_value.paymentPackDocs.filter((paymentFile) => paymentFile.idDomain !== 367 ))
                    setCanApprove(resp.ret_value.canApprove)
                    setIsDenied(resp.ret_value.isDenied)
                } else {
                    mc.error(resp.ret_msg_details);
                }
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
                console.error('fitPostReject - Error:', error);
            });
    };

    ////////////  Dialog ///////////////// 
    const [typeDialog, setTypeDialog] = useState(null);
    const [dialog, setDialog] = useState({
        visible: false,
        title: '',
        icon: 'exclamation',
        args: null
    });

    function handleCancel() {
        setUserComments("");
        setDialog({
            visible: false,
            title: '',
            icon: 'exclamation',
            args: null
        })
    }

    function handleDialog(type) {
        if (type === "Approve") {
            setTypeDialog("Approve");
            setDialog({
                visible: true,
                title: "APPROVE PAYMENT PACK Request",
                icon: "TimesCircle",
                args: null,
            })
        } else {
            setTypeDialog("Reject");
            setDialog({
                visible: true,
                title: "REJECT PAYMENT PACK REQUEST",
                icon: "TimesCircle",
                args: null,
            })
        }
    };

    function handleApproval() {
        loading.start();
        fitinsur.setAuthToken(authContext.token);
        fitinsur.paymentPackApprove(props.match.params.idOperation, userComments)
            .then(response => response.json())
            .then(resp => {
                if (resp.ret_code === 200) {
                    loading.stop();
                    history.push('/list');
                } else {
                    loading.stop();
                    mc.error(resp.ret_msg_details);
                }
            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleApproval.name}\n` + error);
                console.error('fitPostAproval - Error:', error);
            })
        loading.stop();
    };

    function handleReject() {
        loading.start();
        fitinsur.setAuthToken(authContext.token);
        fitinsur.paymentPackReject(props.match.params.idOperation, userComments)
            .then(x => x.json())
            .then(resp => {
                if (resp.ret_code === 200) {
                    loading.stop();
                    mc.success("Approval Payment Pack Rejected");
                    history.push('/list');
                } else {
                    loading.stop();
                    mc.error(resp.ret_msg_details);
                }
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleReject.name}\n` + error);
                console.error('fitPostReject - Error:', error);
            });
        loading.stop();
    };


    const goToLoginPage = () => {
        history.push('login');
    };

    async function handleOperationInfo() {
        loading.start()
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestOperationInfo(props.match.params.idOperation)
          .then(response => response.json())
          .then(response => {
            setIsBound(response?.isBound);
            loading.stop();
          })
          .catch((error) => {
            mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
            loading.stop();
          });
      }  

    useEffect(() => {
        loading.start();
        if (authContext.status !== true) {
            mc.error("Usuário não autenticado");
            goToLoginPage();
            return;
        }
        else {
            fitinsur.setAuthToken(authContext.token);

        };

        let v = handleHistoryMessage()
        if (formik.current) {
            formik.current?.setFieldValue('dealAnalisysInformation', v)
        }
        loading.stop();
    }, [historymsg])


    useEffect(() => {
        if (authContext.status !== true) {
            mc.error("User is not authenticated, please Login");
            loading.stop();
            goToLoginPage();
            return;
        }
        else {
            fitinsur.setAuthToken(authContext.token);
            loading.stop();
        };

        handleFile();
        handleSummary();
        handleOperationInfo();
    }, [])

    function handleMktCompostion() {
        history.push(`/broking/market-composition/${props.match.params.idOperation}`)
    };

    function handlePaymentConfiguration() {
        history.push(`/broking/payment-pack-configuration/${props.match.params.idOperation}`)
    };

    return (
        <Layout
            idOperation={props.match?.params?.idOperation}
            title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
            subtitle={summary.dealCode ? summary.dealCode : "Broking code"}

        >
              <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
            <BrokingSummary data={summary} />
            <ContentCard title={'ANNIVERSARY: PREMIUM NOT PRE AGREED / PAYMENT PACK - APPROVAL' } icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
                <DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
                    {typeDialog === 'Approve' ?
                        <ContentTextArea>
                            <p>Deal Analysis information</p>
                            <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
                            <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
                            <DialogConfirm onClick={() => handleApproval()}>CONFIRM</DialogConfirm>
                        </ContentTextArea>

                        : typeDialog === 'Reject' ?
                            <ContentTextArea>
                                <p>Deal Analysis information</p>
                                <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
                                <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
                                <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
                            </ContentTextArea>
                            : ""
                    }
                </DialogComponent>


                <Formik
                    innerRef={formik}
                    initialValues={{
                        paymentPackMessage: 'Loading...',
                        dealAnalisysInformation: ''
                    }}
                    onSubmit={''}
                >

                    {formikProps => (
                        <Form>
                            <Row>
                                <Col>
                                    <Field
                                        readOnly
                                        label={'Message'}
                                        name={'paymentPackMessage'}
                                        value={formikProps.values.paymentPackMessage}
                                        onChange={(e) => formikProps?.setFieldValue('paymentPackMessage', e)}
                                        component={TextField}
                                    />
                                </Col>
                            </Row>

                            <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
                            <FilesAttachment signedDocs idOperation={props.match.params.idOperation}/>

                            <Field
                                readOnly
                                label={'Deal Analysis Information'}
                                name={'dealAnalisysInformation'}
                                value={formikProps.values.dealAnalisysInformation}
                                onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                                component={TextField}
                            />

                            <ButtonContainer>

                                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                                <HasPermission permission={!isBound}>
                                    <ButtonContent>
                                        {!isDenied && canApprove ?
                                            <HasPermission permission={props.permissions.ENDORSEMENT_PACK_APPROVE_REJECT}>
                                                <Button
                                                    secundary
                                                    type="submit"
                                                    id="btnReject"
                                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Reject"); }}
                                                >
                                                    REJECT
                                                </Button>
                                                <Button
                                                    style={{ marginLeft: "10px" }}
                                                    type="submit"
                                                    primary
                                                    id="btnSubmitApproved"
                                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Approve"); }}
                                                >
                                                    APPROVE
                                                </Button>
                                            </HasPermission> : <></>
                                        }
                                        {isDenied ?
                                            <>
                                                <HasPermission permission={props.permissions.MARKETING_COMPOSITION}>
                                                    <Button
                                                        style={{ marginLeft: "10px" }}
                                                        third
                                                        id="btnSubmitMktComposition"
                                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleMktCompostion() }}
                                                        >
                                                        CDR
                                                    </Button>
                                                </HasPermission>
                                                <HasPermission permission={props.permissions.PAYMENT_PACK_CREATE}>
                                                    <Button
                                                        style={{ marginLeft: "10px" }}
                                                        primary
                                                        type="submit"
                                                        id="btnSubmitPaymentConfiguration"
                                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handlePaymentConfiguration() }}
                                                        >
                                                        REGENERATE PAYMENT DOCS
                                                    </Button>
                                                </HasPermission>
                                            </> : <></>
                                        }
                                    </ButtonContent>
                                </HasPermission>
                            </ButtonContainer>
                        </Form>
                    )}
                </Formik>
            </ContentCard>
            {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
        </Layout>
    );
}